// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReadingItem-module__font-s-10___nLM3m {
  font-size: 10px !important;
}

.ReadingItem-module__font-s-12___xfSyC {
  font-size: 12px !important;
}

.ReadingItem-module__font-s-13___lhk4E {
  font-size: 13px !important;
}

.ReadingItem-module__font-s-14___TnNgP {
  font-size: 14px !important;
}

.ReadingItem-module__font-s-15___LoMW6 {
  font-size: 15px !important;
}

.ReadingItem-module__font-s-16___U1qQp {
  font-size: 16px !important;
}

.ReadingItem-module__font-s-18___nM6NS {
  font-size: 18px !important;
}

.ReadingItem-module__font-s-20___TC6Nc {
  font-size: 20px !important;
}

.ReadingItem-module__font-s-22___j37CP {
  font-size: 22px !important;
}

.ReadingItem-module__font-s-28___siKLW {
  font-size: 28px !important;
}

.ReadingItem-module__font-w-400___x6ors {
  font-weight: 400 !important;
}

.ReadingItem-module__font-w-500___S6zDT {
  font-weight: 500 !important;
}

.ReadingItem-module__font-w-600___e5exE {
  font-weight: 600 !important;
}

.ReadingItem-module__font-w-700___w8XqR {
  font-weight: 700 !important;
}

.ReadingItem-module__p-5___hYx_O {
  padding: 5px !important;
}

.ReadingItem-module__p-12___RrnGS {
  padding: 12px !important;
}

.ReadingItem-module__p-16___zsZkf {
  padding: 16px !important;
}

.ReadingItem-module__p-30___lNt2z {
  padding: 30px !important;
}

.ReadingItem-module__p-b-0___rT4KU {
  padding-bottom: 0 !important;
}

.ReadingItem-module__p-b-5___Kby8K {
  padding-bottom: 5px !important;
}

.ReadingItem-module__p-b-10___LcmBn {
  padding-bottom: 10px !important;
}

.ReadingItem-module__p-b-12___qMLMZ {
  padding-bottom: 12px !important;
}

.ReadingItem-module__p-b-16___XmQWG {
  padding-bottom: 16px !important;
}

.ReadingItem-module__p-b-18___flTGd {
  padding-bottom: 18px !important;
}

.ReadingItem-module__p-b-20___vLRre {
  padding-bottom: 20px !important;
}

.ReadingItem-module__p-b-25___A1KIu {
  padding-bottom: 25px !important;
}

.ReadingItem-module__p-b-30___R8D2B {
  padding-bottom: 30px !important;
}

.ReadingItem-module__p-b-50___E7Lmq {
  padding-bottom: 50px !important;
}

.ReadingItem-module__p-t-0___AtHNH {
  padding-top: 0 !important;
}

.ReadingItem-module__p-t-12___qlbub {
  padding-top: 12px !important;
}

.ReadingItem-module__p-t-16___w6MCE {
  padding-top: 16px !important;
}

.ReadingItem-module__p-t-18___ndrH5 {
  padding-top: 18px !important;
}

.ReadingItem-module__p-t-20___hWJsf {
  padding-top: 20px !important;
}

.ReadingItem-module__p-t-30___TiB8K {
  padding-top: 30px !important;
}

.ReadingItem-module__p-t-40___kY35F {
  padding-top: 40px !important;
}

.ReadingItem-module__p-t-50___SFfvk {
  padding-top: 50px !important;
}

.ReadingItem-module__p-l-20___w2Wtk {
  padding-left: 20px !important;
}

.ReadingItem-module__p-l-30___aa40F {
  padding-left: 30px !important;
}

.ReadingItem-module__p-l-40___O7ZEy {
  padding-left: 40px !important;
}

.ReadingItem-module__p-r-16___lt0hP {
  padding-right: 16px !important;
}

.ReadingItem-module__p-r-20___whSyx {
  padding-right: 20px !important;
}

.ReadingItem-module__p-r-30___f3swS {
  padding-right: 30px !important;
}

.ReadingItem-module__p-r-50___K2d8o {
  padding-right: 50px !important;
}

.ReadingItem-module__p-r-60___lq9Fs {
  padding-right: 60px !important;
}

.ReadingItem-module__m-b-1___t6lW5 {
  margin-bottom: 1px !important;
}

.ReadingItem-module__m-b-2___b7_0M {
  margin-bottom: 2px !important;
}

.ReadingItem-module__m-b-6___k_rju {
  margin-bottom: 6px !important;
}

.ReadingItem-module__m-b-8___rtAAO {
  margin-bottom: 8px !important;
}

.ReadingItem-module__m-b-10___EVAy4 {
  margin-bottom: 10px !important;
}

.ReadingItem-module__m-b-14____mi58 {
  margin-bottom: 14px !important;
}

.ReadingItem-module__m-b-16___sq675 {
  margin-bottom: 16px !important;
}

.ReadingItem-module__m-b-20___Ia0Ni {
  margin-bottom: 20px !important;
}

.ReadingItem-module__m-b-22___p5ZnU {
  margin-bottom: 22px !important;
}

.ReadingItem-module__m-b-24___kTYdB {
  margin-bottom: 24px !important;
}

.ReadingItem-module__m-b-30___k_Qst {
  margin-bottom: 30px !important;
}

.ReadingItem-module__m-b-32____1tP4 {
  margin-bottom: 32px !important;
}

.ReadingItem-module__m-b-40___IFfP9 {
  margin-bottom: 40px !important;
}

.ReadingItem-module__m-t-2___sO1qr {
  margin-top: 2px !important;
}

.ReadingItem-module__m-t-3___N3CdH {
  margin-top: 3px !important;
}

.ReadingItem-module__m-t-4___FoQwo {
  margin-top: 4px !important;
}

.ReadingItem-module__m-t-5___c4Enx {
  margin-top: 5px !important;
}

.ReadingItem-module__m-t-8___zu27A {
  margin-top: 8px !important;
}

.ReadingItem-module__m-t-10___HPzOn {
  margin-top: 10px !important;
}

.ReadingItem-module__m-t-15___BbVC4 {
  margin-top: 15px !important;
}

.ReadingItem-module__m-t-16___gmP8j {
  margin-top: 16px !important;
}

.ReadingItem-module__m-t-20___Ftuoy {
  margin-top: 20px !important;
}

.ReadingItem-module__m-t-22___L5Djv {
  margin-top: 22px !important;
}

.ReadingItem-module__m-t-30___zPtLA {
  margin-top: 30px !important;
}

.ReadingItem-module__m-t-32___RU67W {
  margin-top: 32px !important;
}

.ReadingItem-module__m-l-auto___Az2rD {
  margin-left: auto !important;
}

.ReadingItem-module__m-l-4___Ux7WK {
  margin-left: 4px !important;
}

.ReadingItem-module__m-l-5___zMoEL {
  margin-left: 5px !important;
}

.ReadingItem-module__m-l-6___zlEPR {
  margin-left: 6px !important;
}

.ReadingItem-module__m-l-8___zNV_V {
  margin-left: 8px !important;
}

.ReadingItem-module__m-l-10___g1wj5 {
  margin-left: 10px !important;
}

.ReadingItem-module__m-l-16___QlRar {
  margin-left: 16px !important;
}

.ReadingItem-module__m-l-20___Tfzhu {
  margin-left: 20px !important;
}

.ReadingItem-module__m-l-24___nfnP2 {
  margin-left: 24px !important;
}

.ReadingItem-module__m-l-30___Iyujo {
  margin-left: 30px !important;
}

.ReadingItem-module__m-l-35___DytHl {
  margin-left: 35px !important;
}

.ReadingItem-module__m-l-40___Mcngk {
  margin-left: 40px !important;
}

.ReadingItem-module__m-r-8___GWDkO {
  margin-right: 8px !important;
}

.ReadingItem-module__m-r-10___kA7EO {
  margin-right: 10px !important;
}

.ReadingItem-module__m-r-16___fP9iw {
  margin-right: 16px !important;
}

.ReadingItem-module__m-r-20___rIgIH {
  margin-right: 20px !important;
}

.ReadingItem-module__m-r-24___t89tf {
  margin-right: 24px !important;
}

.ReadingItem-module__m-r-30___nYj8G {
  margin-right: 30px !important;
}

.ReadingItem-module__m-r-40___ShIAd {
  margin-right: 40px !important;
}

.ReadingItem-module__border-r-3___lhfGk {
  border-radius: 3px !important;
}

.ReadingItem-module__border-r-4___bjosp {
  border-radius: 4px !important;
}

.ReadingItem-module__border-r-6___f2KFu {
  border-radius: 6px !important;
}

.ReadingItem-module__border-r-10___YjT5V {
  border-radius: 10px !important;
}

.ReadingItem-module__border-r-12___JM9pL {
  border-radius: 12px !important;
}

.ReadingItem-module__border-r-16___ACqYG {
  border-radius: 16px !important;
}

.ReadingItem-module__border-r-50___Q6xlv {
  border-radius: 50% !important;
}

.ReadingItem-module__primary-border___ipFrt {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ReadingItem-module__primary-border-b___IOEkO {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ReadingItem-module__primary-border-t___PT48E {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ReadingItem-module__primary-border-l___fti7s {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ReadingItem-module__primary-border-r___jkSjY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ReadingItem-module__secondary-border___M5F_C {
  border: 1px solid #637768;
}

.ReadingItem-module__secondary-border-b___LRDk4 {
  border-bottom: 1px solid #637768;
}

.ReadingItem-module__secondary-border-t___YEXke {
  border-top: 1px solid #637768;
}

.ReadingItem-module__secondary-border-l___UjF1_ {
  border-left: 1px solid #637768;
}

.ReadingItem-module__secondary-border-r___IXeTY {
  border-right: 1px solid #637768;
}

.ReadingItem-module__gap-0___J0aAZ {
  gap: 0 !important;
}

.ReadingItem-module__gap-2____foC2 {
  gap: 2px !important;
}

.ReadingItem-module__gap-4___jBl_M {
  gap: 4px !important;
}

.ReadingItem-module__gap-5___uTecm {
  gap: 5px !important;
}

.ReadingItem-module__gap-6___X8yXj {
  gap: 6px !important;
}

.ReadingItem-module__gap-8___PPLdh {
  gap: 8px !important;
}

.ReadingItem-module__gap-10___HGmeA {
  gap: 10px !important;
}

.ReadingItem-module__gap-12___BxbJm {
  gap: 12px !important;
}

.ReadingItem-module__gap-14___waJHX {
  gap: 14px !important;
}

.ReadingItem-module__gap-16___m1FaP {
  gap: 16px !important;
}

.ReadingItem-module__gap-18___L4SLL {
  gap: 18px !important;
}

.ReadingItem-module__gap-20___gr5gO {
  gap: 20px !important;
}

.ReadingItem-module__gap-24___ydGq3 {
  gap: 24px !important;
}

.ReadingItem-module__gap-26___X5gCA {
  gap: 26px !important;
}

.ReadingItem-module__gap-30___glpg1 {
  gap: 30px !important;
}

.ReadingItem-module__gap-32___r9B3S {
  gap: 32px !important;
}

.ReadingItem-module__gap-40___PbFJB {
  gap: 40px !important;
}

.ReadingItem-module__gap-50___pb1ms {
  gap: 50px !important;
}

.ReadingItem-module__flex-1___uVIZl {
  flex: 1;
}

.ReadingItem-module__flex-none___fv8KC {
  flex: none !important;
}

.ReadingItem-module__flex-column___IcLjH {
  display: flex;
  flex-direction: column !important;
}

.ReadingItem-module__flex-row___m8GZn {
  display: flex;
  flex-direction: row !important;
}

.ReadingItem-module__vertically-centered___rKkUO {
  display: flex;
  align-items: center !important;
}

.ReadingItem-module__horizontally-centered___DyCX_ {
  display: flex;
  justify-content: center !important;
}

.ReadingItem-module__horizontally-end___aursP {
  display: flex;
  justify-content: end !important;
}

.ReadingItem-module__vertically-start___yeEHA {
  display: flex;
  align-items: start !important;
}

.ReadingItem-module__space-between___nu23c {
  display: flex;
  justify-content: space-between !important;
}

.ReadingItem-module__flex-wrap___zcZHX {
  flex-wrap: wrap !important;
}

.ReadingItem-module__height-100___Ozph7 {
  height: 100%;
}

.ReadingItem-module__width-50___CYTmD {
  width: 50% !important;
}

.ReadingItem-module__width-100___iub_E {
  width: 100%;
}

.ReadingItem-module__cursor-pointer___z747N {
  cursor: pointer;
}

.ReadingItem-module__cursor-not-allowed___fjnKE {
  cursor: not-allowed !important;
}

.ReadingItem-module__absolute-centered___nWKI5 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ReadingItem-module__absolute___RPvio {
  position: absolute;
}

.ReadingItem-module__relative___j3N7x {
  position: relative;
}

.ReadingItem-module__fixed___c2yh5 {
  position: fixed;
}

.ReadingItem-module__visible___Znc41 {
  opacity: 1;
}

.ReadingItem-module__invisible___SUd5D {
  opacity: 0;
}

.ReadingItem-module__col-90___J2TzG {
  width: 90% !important;
}

.ReadingItem-module__col-auto___UFwEA {
  width: auto !important;
}

.ReadingItem-module__medical-tabs___a_c4y {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ReadingItem-module__medical-table-new___YVs9K {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ReadingItem-module__medical-table-new___YVs9K:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ReadingItem-module__medical-table-new___YVs9K::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ReadingItem-module__medical-table-new___YVs9K::-webkit-scrollbar-track {
  display: none;
}
.ReadingItem-module__medical-table-new___YVs9K.ReadingItem-module__no-pagination___w96_o {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ReadingItem-module__medical-table-new___YVs9K.ReadingItem-module__no-pagination___w96_o:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ReadingItem-module__medical-table-new___YVs9K.ReadingItem-module__no-pagination___w96_o::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ReadingItem-module__medical-table-new___YVs9K.ReadingItem-module__no-pagination___w96_o::-webkit-scrollbar-track {
  display: none;
}

.ReadingItem-module__medical-table-empty___XEWe2 {
  padding: 14px 40px !important;
}

.ReadingItem-module__icon-btn___qpVMz {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ReadingItem-module__search-icon___Zlbew {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ReadingItem-module__disable-select___sqIxG {
  user-select: none;
}

.ReadingItem-module__break-word___oJC45 {
  word-break: break-word;
}

.ReadingItem-module__popup-clear-btn___H6I31 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ReadingItem-module__scroll-m-b-20____NCWa {
  scroll-margin-bottom: 20px;
}

.ReadingItem-module__container___QGH9J {
  color: #859989;
}
.ReadingItem-module__container___QGH9J .ReadingItem-module__content___KUTlO {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/ReadingItem/ReadingItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, medium);\n\n  .content {\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ReadingItem-module__font-s-10___nLM3m`,
	"fontS12": `ReadingItem-module__font-s-12___xfSyC`,
	"fontS13": `ReadingItem-module__font-s-13___lhk4E`,
	"fontS14": `ReadingItem-module__font-s-14___TnNgP`,
	"fontS15": `ReadingItem-module__font-s-15___LoMW6`,
	"fontS16": `ReadingItem-module__font-s-16___U1qQp`,
	"fontS18": `ReadingItem-module__font-s-18___nM6NS`,
	"fontS20": `ReadingItem-module__font-s-20___TC6Nc`,
	"fontS22": `ReadingItem-module__font-s-22___j37CP`,
	"fontS28": `ReadingItem-module__font-s-28___siKLW`,
	"fontW400": `ReadingItem-module__font-w-400___x6ors`,
	"fontW500": `ReadingItem-module__font-w-500___S6zDT`,
	"fontW600": `ReadingItem-module__font-w-600___e5exE`,
	"fontW700": `ReadingItem-module__font-w-700___w8XqR`,
	"p5": `ReadingItem-module__p-5___hYx_O`,
	"p12": `ReadingItem-module__p-12___RrnGS`,
	"p16": `ReadingItem-module__p-16___zsZkf`,
	"p30": `ReadingItem-module__p-30___lNt2z`,
	"pB0": `ReadingItem-module__p-b-0___rT4KU`,
	"pB5": `ReadingItem-module__p-b-5___Kby8K`,
	"pB10": `ReadingItem-module__p-b-10___LcmBn`,
	"pB12": `ReadingItem-module__p-b-12___qMLMZ`,
	"pB16": `ReadingItem-module__p-b-16___XmQWG`,
	"pB18": `ReadingItem-module__p-b-18___flTGd`,
	"pB20": `ReadingItem-module__p-b-20___vLRre`,
	"pB25": `ReadingItem-module__p-b-25___A1KIu`,
	"pB30": `ReadingItem-module__p-b-30___R8D2B`,
	"pB50": `ReadingItem-module__p-b-50___E7Lmq`,
	"pT0": `ReadingItem-module__p-t-0___AtHNH`,
	"pT12": `ReadingItem-module__p-t-12___qlbub`,
	"pT16": `ReadingItem-module__p-t-16___w6MCE`,
	"pT18": `ReadingItem-module__p-t-18___ndrH5`,
	"pT20": `ReadingItem-module__p-t-20___hWJsf`,
	"pT30": `ReadingItem-module__p-t-30___TiB8K`,
	"pT40": `ReadingItem-module__p-t-40___kY35F`,
	"pT50": `ReadingItem-module__p-t-50___SFfvk`,
	"pL20": `ReadingItem-module__p-l-20___w2Wtk`,
	"pL30": `ReadingItem-module__p-l-30___aa40F`,
	"pL40": `ReadingItem-module__p-l-40___O7ZEy`,
	"pR16": `ReadingItem-module__p-r-16___lt0hP`,
	"pR20": `ReadingItem-module__p-r-20___whSyx`,
	"pR30": `ReadingItem-module__p-r-30___f3swS`,
	"pR50": `ReadingItem-module__p-r-50___K2d8o`,
	"pR60": `ReadingItem-module__p-r-60___lq9Fs`,
	"mB1": `ReadingItem-module__m-b-1___t6lW5`,
	"mB2": `ReadingItem-module__m-b-2___b7_0M`,
	"mB6": `ReadingItem-module__m-b-6___k_rju`,
	"mB8": `ReadingItem-module__m-b-8___rtAAO`,
	"mB10": `ReadingItem-module__m-b-10___EVAy4`,
	"mB14": `ReadingItem-module__m-b-14____mi58`,
	"mB16": `ReadingItem-module__m-b-16___sq675`,
	"mB20": `ReadingItem-module__m-b-20___Ia0Ni`,
	"mB22": `ReadingItem-module__m-b-22___p5ZnU`,
	"mB24": `ReadingItem-module__m-b-24___kTYdB`,
	"mB30": `ReadingItem-module__m-b-30___k_Qst`,
	"mB32": `ReadingItem-module__m-b-32____1tP4`,
	"mB40": `ReadingItem-module__m-b-40___IFfP9`,
	"mT2": `ReadingItem-module__m-t-2___sO1qr`,
	"mT3": `ReadingItem-module__m-t-3___N3CdH`,
	"mT4": `ReadingItem-module__m-t-4___FoQwo`,
	"mT5": `ReadingItem-module__m-t-5___c4Enx`,
	"mT8": `ReadingItem-module__m-t-8___zu27A`,
	"mT10": `ReadingItem-module__m-t-10___HPzOn`,
	"mT15": `ReadingItem-module__m-t-15___BbVC4`,
	"mT16": `ReadingItem-module__m-t-16___gmP8j`,
	"mT20": `ReadingItem-module__m-t-20___Ftuoy`,
	"mT22": `ReadingItem-module__m-t-22___L5Djv`,
	"mT30": `ReadingItem-module__m-t-30___zPtLA`,
	"mT32": `ReadingItem-module__m-t-32___RU67W`,
	"mLAuto": `ReadingItem-module__m-l-auto___Az2rD`,
	"mL4": `ReadingItem-module__m-l-4___Ux7WK`,
	"mL5": `ReadingItem-module__m-l-5___zMoEL`,
	"mL6": `ReadingItem-module__m-l-6___zlEPR`,
	"mL8": `ReadingItem-module__m-l-8___zNV_V`,
	"mL10": `ReadingItem-module__m-l-10___g1wj5`,
	"mL16": `ReadingItem-module__m-l-16___QlRar`,
	"mL20": `ReadingItem-module__m-l-20___Tfzhu`,
	"mL24": `ReadingItem-module__m-l-24___nfnP2`,
	"mL30": `ReadingItem-module__m-l-30___Iyujo`,
	"mL35": `ReadingItem-module__m-l-35___DytHl`,
	"mL40": `ReadingItem-module__m-l-40___Mcngk`,
	"mR8": `ReadingItem-module__m-r-8___GWDkO`,
	"mR10": `ReadingItem-module__m-r-10___kA7EO`,
	"mR16": `ReadingItem-module__m-r-16___fP9iw`,
	"mR20": `ReadingItem-module__m-r-20___rIgIH`,
	"mR24": `ReadingItem-module__m-r-24___t89tf`,
	"mR30": `ReadingItem-module__m-r-30___nYj8G`,
	"mR40": `ReadingItem-module__m-r-40___ShIAd`,
	"borderR3": `ReadingItem-module__border-r-3___lhfGk`,
	"borderR4": `ReadingItem-module__border-r-4___bjosp`,
	"borderR6": `ReadingItem-module__border-r-6___f2KFu`,
	"borderR10": `ReadingItem-module__border-r-10___YjT5V`,
	"borderR12": `ReadingItem-module__border-r-12___JM9pL`,
	"borderR16": `ReadingItem-module__border-r-16___ACqYG`,
	"borderR50": `ReadingItem-module__border-r-50___Q6xlv`,
	"primaryBorder": `ReadingItem-module__primary-border___ipFrt`,
	"primaryBorderB": `ReadingItem-module__primary-border-b___IOEkO`,
	"primaryBorderT": `ReadingItem-module__primary-border-t___PT48E`,
	"primaryBorderL": `ReadingItem-module__primary-border-l___fti7s`,
	"primaryBorderR": `ReadingItem-module__primary-border-r___jkSjY`,
	"secondaryBorder": `ReadingItem-module__secondary-border___M5F_C`,
	"secondaryBorderB": `ReadingItem-module__secondary-border-b___LRDk4`,
	"secondaryBorderT": `ReadingItem-module__secondary-border-t___YEXke`,
	"secondaryBorderL": `ReadingItem-module__secondary-border-l___UjF1_`,
	"secondaryBorderR": `ReadingItem-module__secondary-border-r___IXeTY`,
	"gap0": `ReadingItem-module__gap-0___J0aAZ`,
	"gap2": `ReadingItem-module__gap-2____foC2`,
	"gap4": `ReadingItem-module__gap-4___jBl_M`,
	"gap5": `ReadingItem-module__gap-5___uTecm`,
	"gap6": `ReadingItem-module__gap-6___X8yXj`,
	"gap8": `ReadingItem-module__gap-8___PPLdh`,
	"gap10": `ReadingItem-module__gap-10___HGmeA`,
	"gap12": `ReadingItem-module__gap-12___BxbJm`,
	"gap14": `ReadingItem-module__gap-14___waJHX`,
	"gap16": `ReadingItem-module__gap-16___m1FaP`,
	"gap18": `ReadingItem-module__gap-18___L4SLL`,
	"gap20": `ReadingItem-module__gap-20___gr5gO`,
	"gap24": `ReadingItem-module__gap-24___ydGq3`,
	"gap26": `ReadingItem-module__gap-26___X5gCA`,
	"gap30": `ReadingItem-module__gap-30___glpg1`,
	"gap32": `ReadingItem-module__gap-32___r9B3S`,
	"gap40": `ReadingItem-module__gap-40___PbFJB`,
	"gap50": `ReadingItem-module__gap-50___pb1ms`,
	"flex1": `ReadingItem-module__flex-1___uVIZl`,
	"flexNone": `ReadingItem-module__flex-none___fv8KC`,
	"flexColumn": `ReadingItem-module__flex-column___IcLjH`,
	"flexRow": `ReadingItem-module__flex-row___m8GZn`,
	"verticallyCentered": `ReadingItem-module__vertically-centered___rKkUO`,
	"horizontallyCentered": `ReadingItem-module__horizontally-centered___DyCX_`,
	"horizontallyEnd": `ReadingItem-module__horizontally-end___aursP`,
	"verticallyStart": `ReadingItem-module__vertically-start___yeEHA`,
	"spaceBetween": `ReadingItem-module__space-between___nu23c`,
	"flexWrap": `ReadingItem-module__flex-wrap___zcZHX`,
	"height100": `ReadingItem-module__height-100___Ozph7`,
	"width50": `ReadingItem-module__width-50___CYTmD`,
	"width100": `ReadingItem-module__width-100___iub_E`,
	"cursorPointer": `ReadingItem-module__cursor-pointer___z747N`,
	"cursorNotAllowed": `ReadingItem-module__cursor-not-allowed___fjnKE`,
	"absoluteCentered": `ReadingItem-module__absolute-centered___nWKI5`,
	"absolute": `ReadingItem-module__absolute___RPvio`,
	"relative": `ReadingItem-module__relative___j3N7x`,
	"fixed": `ReadingItem-module__fixed___c2yh5`,
	"visible": `ReadingItem-module__visible___Znc41`,
	"invisible": `ReadingItem-module__invisible___SUd5D`,
	"col90": `ReadingItem-module__col-90___J2TzG`,
	"colAuto": `ReadingItem-module__col-auto___UFwEA`,
	"medicalTabs": `ReadingItem-module__medical-tabs___a_c4y`,
	"medicalTableNew": `ReadingItem-module__medical-table-new___YVs9K`,
	"noPagination": `ReadingItem-module__no-pagination___w96_o`,
	"medicalTableEmpty": `ReadingItem-module__medical-table-empty___XEWe2`,
	"iconBtn": `ReadingItem-module__icon-btn___qpVMz`,
	"searchIcon": `ReadingItem-module__search-icon___Zlbew`,
	"disableSelect": `ReadingItem-module__disable-select___sqIxG`,
	"breakWord": `ReadingItem-module__break-word___oJC45`,
	"popupClearBtn": `ReadingItem-module__popup-clear-btn___H6I31`,
	"scrollMB20": `ReadingItem-module__scroll-m-b-20____NCWa`,
	"container": `ReadingItem-module__container___QGH9J`,
	"content": `ReadingItem-module__content___KUTlO`
};
module.exports = ___CSS_LOADER_EXPORT___;
